<template>
  <div class="contract-data">
    <h2 class="contract-data__headline">Mein Service-Anbieter Strom</h2>

    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">Adresse</h3>
      <address>
        <div>{{ $store.state.cube.supplier.name }}</div>
        <div>
          {{ $store.state.cube.supplier.street }}
          {{ $store.state.cube.supplier.street_number }}
        </div>
        <div>
          {{ $store.state.cube.supplier.zip_code }}
          {{ $store.state.cube.supplier.city }}
        </div>
      </address>
    </div>
    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">Support</h3>
      <a
        class="contract-data__support"
        :href="`tel:${$store.state.cube.supplier.phone}`"
        >{{ $store.state.cube.supplier.phone }}</a
      >
      <a
        class="contract-data__support"
        :href="`mailto:${$store.state.cube.supplier.email}`"
        >{{ $store.state.cube.supplier.email }}</a
      >
    </div>

    <h2 class="contract-data__headline">Vertrag</h2>

    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">Nickname</h3>
      {{ $store.getters.nickName }}
    </div>

    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">Connect Tarif</h3>
      {{ $store.getters.planName }}
    </div>

    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">Zählpunktnummer</h3>
      {{ $store.getters.contractData.meterPointId }}
    </div>

    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">Vertragsnummer</h3>
      {{ $store.getters.contractData.contractId }}
    </div>

    <div class="contract-data__field">
      <h3 class="contract-data__label">Name</h3>
      {{ $store.getters.contractData.fullName }}
    </div>

    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">E-Mail</h3>
      {{ $store.getters.contractData.email }}
    </div>

    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">Telefon</h3>
      {{ $store.getters.contractData.phone }}
    </div>

    <h2 class="contract-data__headline">Lieferadresse</h2>

    <div class="contract-data__field">
      <h3 class="contract-data__label">Adresse</h3>
      {{ $store.getters.contractData.cubeAddress.address }}
    </div>

    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">Plz, Ort</h3>
      {{ $store.getters.contractData.cubeAddress.zip }}
      {{ $store.getters.contractData.cubeAddress.city }}
    </div>

    <div class="contract-data__field contract-data__field--2-columns">
      <h3 class="contract-data__label">Land</h3>
      {{ $store.getters.contractData.cubeAddress.country }}
    </div>

    <h2 class="contract-data__headline">Rechnungsadresse</h2>

    <template v-if="differentBillingAddress">
      <div class="contract-data__field">
        <h3 class="contract-data__label">Adresse</h3>
        {{ $store.getters.contractData.billingAddress.address }}
      </div>

      <div class="contract-data__field contract-data__field--2-columns">
        <h3 class="contract-data__label">Plz, Ort</h3>
        {{ $store.getters.contractData.billingAddress.zip }}
        {{ $store.getters.contractData.billingAddress.city }}
      </div>

      <div class="contract-data__field contract-data__field--2-columns">
        <h3 class="contract-data__label">Land</h3>
        {{ $store.getters.contractData.billingAddress.country }}
      </div>
    </template>
    <template v-else>
      <p>Die Rechnungsadresse enspricht deiner Lieferadresse.</p>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'contract-data',
    computed: {
      differentBillingAddress: function () {
        const data = this.$store.getters.contractData

        if (data.cubeAddress.address !== data.billingAddress.address) {
          return true
        }

        if (data.cubeAddress.zip !== data.billingAddress.zip) {
          return true
        }

        if (data.cubeAddress.city !== data.billingAddress.city) {
          return true
        }

        if (data.cubeAddress.country !== data.billingAddress.country) {
          return true
        }

        return false
      },
    },
  }
</script>

<style lang="scss">
  .contract-data {
    display: flex;
    flex-wrap: wrap;

    &__headline {
      margin-top: spacer(2);
      margin-bottom: spacer(0.5);
      flex-basis: 100%;

      &:first-child {
        margin-top: 0;
      }
    }

    &__field {
      font-size: $font-size-lg;
      flex-basis: 100%;
      margin-bottom: spacer(0.5);

      &--2-columns {
        @media (min-width: $bp-lg) {
          flex-basis: 50%;
        }
      }
    }

    &__label {
      margin-bottom: 0;
      font-size: $font-size-base;
      font-weight: inherit;
      color: $grey-dark;
      line-height: $line-height-sm;
    }

    &__support {
      display: block;
      color: inherit;
    }
  }
</style>
